export default "__VITE_ASSET__iRwZ4wz2__"